import { isNullOrEmpty, isEmptyObject, getOrderMoneyPayType } from '@/utils'
import {
  E_PROMOTION_TYPE,
  RECOVERY_CATEGORY_ID,
  NEWBABY_CATEGORY_ID,
  UNION_YUESAO_ID,
  ORDER_STATUS,
  PROMOTION_TYPES
} from '@/config'
import { COUPON_CATEGORY_TYPE } from '@/business/coupon'
import B_COUPON from '@/business/coupon'
import iconUserGold from '@/assets/images/icon_user_gold.png'
import iconUserPregnant from '@/assets/images/icon_user_pregnant.png'
import iconUserCertify from '@/assets/images/icon_user_certify.png'

export default {
  computed: {
    // isPayPeriod:0 // 是否为定金尾款单 0 否 1 是
    isStepOrder() {
      const { isPayPeriod } = this.order
      return isPayPeriod === ORDER_STATUS.stepOrder
    },
    PayType() {
      return getOrderMoneyPayType(this.order)
    },
    /* 是否有多个商品规格 */
    multiCmmdtySpecs() {
      return this.product.cmmdtySpecs && this.product.cmmdtySpecs.length > 1
    },
    moreCmmdtySpecs() {
      return (
        this.multiCmmdtySpecs && !(this.selectedSku && this.selectedSku.skuId)
      )
    },
    isRebuilding() {
      // 产后恢复
      return (
        this.product &&
        this.product.spuId &&
        this.product.level4CategoryId &&
        (parseInt(+this.product.level4CategoryId / 100, 0) ==
          RECOVERY_CATEGORY_ID ||
          parseInt(+this.product.level4CategoryId / 100, 0) ==
            NEWBABY_CATEGORY_ID)
      )
    },
    isPopYuesao() {
      // 联营月嫂
      return (
        this.product &&
        this.product.spuId &&
        this.product.level4CategoryId == UNION_YUESAO_ID
      )
    },

    // 商品支持定金+尾款模式
    isSupportDeposit() {
      return (spec = null) => {
        if (spec) {
          if (spec.skuId && +spec.supportPayment === 1) {
            return true
          }
          return false
        } else {
          // eslint-disable-next-line no-restricted-syntax
          for (const item of this.product.cmmdtySpecs) {
            if (+item.supportPayment === 1) {
              return true
            }
          }
          return false
        }
      }
    },

    // 普通售卖价
    normalPrice() {
      let num = null
      let showQi = false
      if (this.selectedSku && this.selectedSku.skuId) {
        num = this.selectedSku.price / 100
      } else if (this.product.maxPrice === 0 && this.product.minPrice === 0) {
        num = this.product.minPrice / 100
      } else if (this.product.minPrice === this.product.maxPrice) {
        num = this.product.minPrice / 100
      } else {
        num = this.product.minPrice / 100
        showQi = true
      }
      return {
        num,
        showQi
      }
    },
    // 售卖积分
    payScore() {
      let num = null
      if (this.selectedSku && this.selectedSku.skuId) {
        num = this.selectedSku.payScore
      } else {
        num = this.product.minPayScore
      }
      return {
        num,
        showQi: this.normalPrice.showQi
      }
    },
    // 客群价
    userGroupPrice() {
      let num = null
      let showQi = false
      if (
        this.selectedSku && this.selectedSku.skuId
          ? this.selectedSku.customerPrice == null
          : this.product.minCustomerPrice == null
      ) {
        return {
          num,
          showQi
        }
      }
      if (this.selectedSku && this.selectedSku.skuId) {
        num = this.selectedSku.customerPrice / 100
      } else if (this.product.maxPrice === 0 && this.product.minPrice === 0) {
        num = this.product.minCustomerPrice / 100
      } else if (this.product.minPrice === this.product.maxPrice) {
        num = this.product.minCustomerPrice / 100
      } else {
        num = this.product.minCustomerPrice / 100
        showQi = true
      }
      return {
        num,
        showQi
      }
    },
    // 普通售卖价html
    priceSection() {
      if (!this.normalPrice.showQi) {
        return `<i>&yen;</i>${this.normalPrice.num}`
      } else {
        return `<i>&yen;</i>${this.normalPrice.num}<i>起</i>`
      }
    },
    // 售卖积分html
    scoreSection() {
      if (!this.payScore.showQi) {
        return `${this.payScore.num}<i>积分</i>`
      } else {
        return `${this.payScore.num}<i>积分起</i>`
      }
    },
    // 客群价html
    userGroupPriceSection() {
      if (!this.userGroupPrice.num) {
        return ''
      }
      if (!this.userGroupPrice.showQi) {
        return `<i>&yen;</i>${this.userGroupPrice.num}`
      } else {
        return `<i>&yen;</i>${this.userGroupPrice.num}<i>起</i>`
      }
    },
    // 目标客群标签
    userGroupImg() {
      if (this.selectedSku && this.selectedSku.skuId) {
        if (this.selectedSku.customerType == 1) {
          return iconUserGold
        } else if (this.selectedSku.customerType == 2) {
          return iconUserPregnant
        } else if (this.selectedSku.customerType == 3) {
          return iconUserCertify
        }
      } else {
        if (this.product.customerType == 1) {
          return iconUserGold
        } else if (this.product.customerType == 2) {
          return iconUserPregnant
        } else if (this.product.customerType == 3) {
          return iconUserCertify
        }
      }
      return ''
    },

    //产康福袋信息
    blessingBag() {
      return this.product.blessingBag
    },
    //符合条件0元领取
    isBlessEligible() {
      return (
        this.blessingBag &&
        this.blessingBag.hasUserMatch === 1 &&
        this.blessingBag.hasReceive === 0
      )
    },
    //符合条件积分购买
    isBlessScorable() {
      return (
        this.blessingBag &&
        this.blessingBag.hasUserMatch === 2 &&
        this.blessingBag.hasReceive === 0
      )
    },
    //福袋是否领取
    isBlessReceived() {
      return this.blessingBag && this.blessingBag.hasReceive === 1
    },
    blessImg() {
      if (this.blessingBag) {
        if (this.isBlessReceived) {
          return require('@/assets/images/bg_received_bag.png')
        } else if (this.blessingBag && this.blessingBag.hasUserMatch === 0) {
          return require('@/assets/images/bg_unfit_bag.png')
        } else {
          if (this.blessingBag.type === 1) {
            return require('@/assets/images/bg_grow_bag.png')
          } else if (this.blessingBag.type === 2) {
            return require('@/assets/images/bg_yunma_bag.png')
          } else if (this.blessingBag.type === 3) {
            return require('@/assets/images/bg_growyunma_bag.png')
          }
        }
      }
    },

    mixInfo() {
      // const _mixProm = this.promotionInfo && this.promotionInfo.mixPromList[0]
      // console.log('this.promotionInfo', this.promotionInfo);
      // 这块需要大改下逻辑，使用mixPromList字段里的优惠信息和商券信息更清晰，测试没排期，暂不修改
      if (isEmptyObject(this.promotionInfo)) {
        return {}
      }
      const {
        mixPromList = [],
        promList = [],
        returnServiceCoupons = [],
        preHeatPromRule,
        currentDate = new Date().getTime()
      } = this.promotionInfo

      const hasPrmList = promList.length > 0

      const IS_HASE_PROM = mixPromList.length > 0

      const hasBusinessCoupon =
        IS_HASE_PROM &&
        mixPromList.filter(
          i =>
            i.couponDto &&
            i.couponDto.couponCategory * 1 === COUPON_CATEGORY_TYPE.BUSINESS
        ).length > 0

      const onlyHasBusinessCoupon = () => {
        let _arr = []
        IS_HASE_PROM &&
          mixPromList.forEach(e => {
            if (e.couponDto) {
              _arr.push(e.couponDto)
            }
          })
        return !_arr.find(
          i => i.couponCategory * 1 === COUPON_CATEGORY_TYPE.PLATFORM
        )
      }

      // 纯满赠优惠列表
      const pure_reward_promlist =
        IS_HASE_PROM &&
        mixPromList.filter(
          i =>
            i.promList.length > 0 &&
            i.promList[0].type * 1 === E_PROMOTION_TYPE.REWARD_GIFT
        )
      // 纯秒杀优惠列表
      const pure_flash_promlist =
        IS_HASE_PROM &&
        mixPromList
          .filter(
            i =>
              i.promList.length > 0 &&
              i.promList[0].type * 1 === E_PROMOTION_TYPE.FLASH_SALE
          )
          .sort((a, b) => a.minPrice - b.minPrice)

      const IS_PURE_REWARD_GIFT =
        IS_HASE_PROM && pure_reward_promlist.length === mixPromList.length

      const isReallyCheap = IS_HASE_PROM && !IS_PURE_REWARD_GIFT

      //预热时间
      let preheatingInfo = null
      if (preHeatPromRule) {
        const startTime = getTime(preHeatPromRule.startTime)
        const preheatingDate = +preHeatPromRule.preheatingDate || 0
        const isPreheatingDate =
          startTime - preheatingDate * 24 * 60 * 60 * 1000 <= currentDate
        if (isPreheatingDate && startTime > currentDate) {
          preheatingInfo = {
            countDownTime: startTime - currentDate,
            price: preHeatPromRule.promPrice
          }
        }
      }
      const isSeckill = pure_flash_promlist.length > 0

      let couponDto = {},
        minPrice = 0,
        promForMinPriceList = []

      //  如果是秒杀的时候，使用“含有秒杀的最低价”作为预估到手的最低价显示
      if (isSeckill) {
        couponDto = pure_flash_promlist[0].couponDto
        minPrice = pure_flash_promlist[0].minPrice
        promForMinPriceList = pure_flash_promlist[0].promList
      } else if (mixPromList.length > 0) {
        couponDto = mixPromList[0].couponDto
        minPrice = mixPromList[0].minPrice
        promForMinPriceList = mixPromList[0].promList
      }

      // 底下情况是，优惠信息里应该把满赠去掉，因为满赠在计算是否组合优惠抑或其他的时候，不参与计算
      // eslint-disable-next-line array-callback-return
      promForMinPriceList = promForMinPriceList.filter(
        i => i.type * 1 !== E_PROMOTION_TYPE.REWARD_GIFT
      )

      let buyNowTitle =
        !isEmptyObject(couponDto) &&
        promForMinPriceList.length === 0 &&
        !hasPrmList
          ? '领券购买'
          : '立即购买'
      // 弱化预付定金模式
      // if (this.isSupportDeposit(this.selectedSku)) {
      //   buyNowTitle = '支付定金'
      // }

      let buyNowSubtitle = ''

      // 券为空 优惠信息第一个是立减
      const onlyDisCount = () => {
        let _ =
          promForMinPriceList.length > 0 &&
          promForMinPriceList[0].type === E_PROMOTION_TYPE.DISCOUNT &&
          isNullOrEmpty(couponDto)
        return _
      }
      // 券为空 优惠信息第一个是秒杀
      const onlyFlashSale = () => {
        let _ =
          promForMinPriceList.length > 0 &&
          promForMinPriceList[0].type === E_PROMOTION_TYPE.FLASH_SALE &&
          isNullOrEmpty(couponDto)
        return _
      }

      // 券不为空 且没有除满赠之外的其他优惠信息 券后价
      // 因为商家券和立减不能共存，所以，
      // 有商家券的话，（且最优惠的时候是商家券）会显示券后价。
      const showCoupon = () => {
        let _ =
          (couponDto &&
            promForMinPriceList.length === 0 &&
            !hasBusinessCoupon) ||
          (couponDto &&
            !hasPrmList &&
            couponDto.couponCategory &&
            hasBusinessCoupon)
        return _
      }

      const showFlash = () => {
        let _ =
          (!hasBusinessCoupon && onlyFlashSale()) ||
          (onlyHasBusinessCoupon() &&
            promForMinPriceList.length > 0 &&
            promForMinPriceList[0].type === E_PROMOTION_TYPE.FLASH_SALE)
        return _
      }

      if (onlyDisCount() && !hasBusinessCoupon) {
        buyNowSubtitle = '减后价'
      } else if (showFlash()) {
        buyNowSubtitle = '秒杀价'
      } else if (showCoupon()) {
        buyNowSubtitle = '券后价'
      } else {
        buyNowSubtitle = '预估到手价'
      }

      const seckillData =
        Array.isArray(promForMinPriceList) &&
        promForMinPriceList.filter(
          i => i.type * 1 === E_PROMOTION_TYPE.FLASH_SALE
        )

      // console.log('seckillData is', seckillData)

      // 定金尾款文描
      let depositTips = ''
      if (this.isSupportDeposit()) {
        if (this.moreCmmdtySpecs) {
          // 多规格
          depositTips = '部分产品规格支持定金支付'
        } else if (this.selectedSku && this.selectedSku.skuId) {
          // 已选规格
          if (
            this.selectedSku.paymentDepositPrice &&
            this.selectedSku.paymentDepositPrice > 0
          ) {
            const endPrice =
              minPrice > 0
                ? minPrice - this.selectedSku.paymentDepositPrice
                : this.selectedSku.paymentEndPrice

            depositTips = `预付定金¥${
              this.selectedSku.paymentDepositPrice / 100
            }, 尾款¥${endPrice / 100}`
          } else {
            depositTips = '部分产品规格支持定金支付'
          }
        }
      }

      const getReturnServiceCouponsPrefix = price => {
        const p = price ?? 0
        if (p && typeof p === 'number') {
          return `实付满${p / 100}元`
        }
        return ''
      }

      //分享促销标签
      //促销标签：按照“秒杀>拼团>X元购>立减>优惠券>返券>赠品”优先级显示其中之一。秒杀标签显示为“秒杀”；拼团标签多团显示“X人团”，单团显示“拼团”；X元购标签显示为“特惠X元抢购”；立减标签显示为“立减￥X”；优惠券优先显示面额最大的券，满减券显示为“满X减Y”，无门槛券显示为“X元现金券”。
      let tag = ''
      let tagName = '' //防止tag过长
      let isDisCountOrXBuy = false //是否是立减或者x元购
      if (hasPrmList) {
        const result = promList[0]
        tagName = PROMOTION_TYPES.get(result.type * 1)
        if (
          result.type * 1 === E_PROMOTION_TYPE.DISCOUNT ||
          result.type * 1 === E_PROMOTION_TYPE.XBUY_EVENT
        ) {
          isDisCountOrXBuy = true
        }
      }
      if (isDisCountOrXBuy) {
        const firstProm = promList[0]
        if (firstProm.type * 1 === E_PROMOTION_TYPE.DISCOUNT) {
          tag = `立減${firstProm.promotionPrice / 100}元`
        } else if (firstProm.type * 1 === E_PROMOTION_TYPE.XBUY_EVENT) {
          tag = `特惠${firstProm.promotionPrice / 100}元抢购`
        }
      } else if (couponDto && !isEmptyObject(couponDto)) {
        tag = B_COUPON.getCouponText1(couponDto)
      } else if (returnServiceCoupons.length > 0) {
        if (
          returnServiceCoupons[0].couponVoList &&
          returnServiceCoupons[0].couponVoList.length > 0
        ) {
          tag = `${getReturnServiceCouponsPrefix(
            returnServiceCoupons[0].minPayPrice
          )}下单返${returnServiceCoupons[0].couponVoList
            .map(item => item.couponName)
            .join('、')}`
          tagName = '返券'
        }
      } else {
        if (hasPrmList) {
          tag = promList[0].promotionName
        }
      }
      return {
        isReallyCheap,
        isSeckill,
        minPrice: minPrice / 100,
        buyNowTitle,
        buyNowSubtitle,
        promForMinPriceList,
        seckillData: (seckillData && seckillData[0]) || {},
        preheatingInfo,
        depositTips,
        tag,
        tagName
      }
    }
  }
}

function getTime(time) {
  const ts =
    typeof time === 'string' ? time.toString().replace(/-/g, '/') : time
  const t = ts && new Date(ts).getTime()
  return t
}
